import React from 'react';
import { Body, Box } from '@hover/blueprint';

interface SlideProps {
  beforeImage: React.ReactNode;
  afterImage: React.ReactNode;
}

const Slide: React.FC<SlideProps> = ({ beforeImage, afterImage }) => (
  <Box
    w="100%"
    h={{ base: 'auto', desktop: '374px' }}
    alignItems="center"
    flexDir={{ base: 'column', desktop: 'row' }}
  >
    <Box
      h={{ base: 'auto', desktop: '374px' }}
      w={{ base: 'calc(100% - 20px)', tablet: '665px' }}
      pos="relative"
      borderRadius={{ base: '0px', tablet: '8px' }}
      overflow="hidden"
      ml={{ base: '0px', desktop: '39px' }}
      mb={{ base: '8px', desktop: '0px' }}
      justifyContent="center"
    >
      <Body
        size={300}
        isBold
        position="absolute"
        top={5}
        left={6}
        borderRadius={4}
        padding="8px 16px"
        bgColor="rgba(0, 0, 0, 0.65)"
        color="white"
        height="auto !important"
        zIndex={1}
      >
        BEFORE
      </Body>
      {beforeImage}
    </Box>
    <Box
      h={{ base: 'auto', tablet: '374px' }}
      w={{ base: 'calc(100% - 20px)', tablet: '665px' }}
      pos="relative"
      borderRadius={{ base: '0px', tablet: '8px' }}
      overflow="hidden"
      ml={{ base: '0px', tablet: '32px' }}
      mr={{ base: '0px', tablet: '39px' }}
      justifyContent="center"
    >
      <Body
        size={300}
        isBold
        position="absolute"
        top={5}
        right={{ base: 'auto', tablet: '1.5rem' }}
        left={{ base: '1.5rem', tablet: 'auto' }}
        borderRadius={4}
        padding="8px 16px"
        bgColor="rgba(0, 0, 0, 0.65)"
        color="white"
        height="auto !important"
        zIndex={1}
      >
        AFTER
      </Body>
      {afterImage}
    </Box>
  </Box>
);

export default Slide;
